import axios from "axios";
import Swal from "sweetalert2";
import api from "./api_refresh_token";
import { isObject } from "formik";
import { baseURL } from "./api_base";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer


//Token
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

//acesso do perfil
const buildURL = (baseURL, idperfil) => {
  // Substitui parâmetros vazios por '0'
  idperfil = idperfil || "0";

  return `${baseURL}/perfil_acessos/${idperfil}`;
};

export const getPerfilAcessos = (idperfil = "") => {
  const url = buildURL(baseURL, idperfil);

  return api
    .get(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
    .then((response) => {
      //console.log(response.data, "retorno de dados do acesso"); // Verifica o retorno dos dados
      return response.data; // Retorna os dados de acesso
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    });
};

export const updatePerfilAcessos = (permissoes) =>
  api
    .put(
      `${baseURL}/perfil_acesso_update`,
      permissoes, // Passa o corpo da requisição com os acessos atualizados
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      //console.log(response.data, "dados do update api"); // Verifica a resposta
      Swal.fire({
        icon: "success",
        title: "Acessos atualizados com sucesso",
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    });
